import {Component} from '@angular/core';

import {AppAlertService, SubtitlesService} from "../../../core";

@Component({
    selector: 'regulations-kolton-pl',
    templateUrl: './regulations-kolton-pl.component.html',
    styleUrls: ['./regulations-kolton-pl.component.scss']
})
export class RegulationsKoltonPlComponent {
    constructor(
        public appAlert: AppAlertService,
        public subtitles: SubtitlesService,
    ) {
    }
}
